/**
 * @congress/auth-helper v1.0.0
 * @version 1.0.0
 * @license CYIM: www.cyim.com
 */

import DrupalService from './DrupalService.js';
import KeycloakService from './KeycloakService.js';
import CyimService from './CyimService.js';
import AuthType from './AuthType.enum.js';
import ClientService from './ClientService.js';
class AuthHelper {
  /**
   * Default constructor to use authentication
   * @constructor AuthHelper
   * @example
   * // Use like this
   * const auth = new AuthHelper(AuthType.KEYCLOAK, { realm: ... });
   * // Or this
   * const auth = new AuthHelper(AuthType.DRUPAL);
   * // Or this
   * const auth = new AuthHelper(AuthType.CLIENT, myToken);
   * @param {AuthHelper.AuthType} type - Authentication type
   * @param options
   * @throws {"A type is required to choose your authentication"}
   * @returns {KeycloakService|DrupalService|CyimService|null}
   */
  constructor(type, options) {
    let auth = null;
    switch (type) {
      case AuthHelper.AuthType.DRUPAL:
        auth = options ? new DrupalService(options) : new DrupalService();
        break;
      case AuthHelper.AuthType.KEYCLOAK:
        auth = new KeycloakService(options);
        break;
      case AuthHelper.AuthType.CYIM:
        auth = new CyimService();
        break;
      case AuthHelper.AuthType.CLIENT:
        auth = new ClientService(options);
        break;
      default:
        throw "A type is required to choose your authentication";
    }
    if (auth) {
      window.AuthHelper = auth;
    }
    return auth;
  }
  static get AuthType() {
    return AuthType;
  }
}
export { AuthHelper as default };
//# sourceMappingURL=index.js.map
